// extracted by mini-css-extract-plugin
module.exports = {"numlist":"Terms_numlist_3Eb3v","bracketslist":"Terms_bracketslist_Z_aJR","description":"Terms_description_2NZwB","only":"Terms_only_2A1DR","title":"Terms_title_jqZMz"};